<template>
  <!-- ========================= -->
  <!-- TAB: MAGIC                -->
  <!-- ========================= -->
  <div>
    <div class="row mt-2 mb-2"></div>
    <p class="bb-hdg mt-2 mb-3">Magic Details</p>
    <div v-if="hasItemName">
      <!-- -------------- -->
      <!--     ROW 1      -->
      <!-- -------------- -->
      <!-- ------------------------- -->
      <!--  integrated runes (r/o)   -->
      <!-- ------------------------- -->
      <div class="row mt-2 mb-2"></div>
      <p class="bb-sub-hdg mt-3 mb-3">Integrated Runes</p>
      <div class="row mt-2 mb-2">
        <component
          style="display: block"
          :is="hasTooltip(item_runes_integrated) ? 'ToolTip' : 'div'"
          v-bind="
            hasTooltip(item_runes_integrated)
              ? { text: item_runes_integrated, position: 'top' }
              : {}
          "
        >
          <div class="form-group">
            <div class="form-floating">
              <input
                readonly
                class="form-control"
                :value="item_runes_integrated || 'None'"
                id="item_runes_integrated"
                disabled
              />
              <label
                class="bb-float-label optional"
                for="item_runes_integrated"
              >
                Runes
                <span
                  v-if="hasTooltip(item_runes_integrated)"
                  class="bb-orange-circle"
                ></span>
              </label>
            </div>
          </div>
        </component>
      </div>
      <!-- -------------- -->
      <!--     ROW 2      -->
      <!-- -------------- -->
      <!-- --------------------------- -->
      <!--  unintegrated runes (r/o)   -->
      <!-- --------------------------- -->
      <p class="bb-sub-hdg mb-3 mt-2">Unintegrated Runes</p>
      <div class="row mt-2 mb-2">
        <component
          style="display: block"
          :is="hasTooltip(item_runes_unintegrated) ? 'ToolTip' : 'div'"
          v-bind="
            hasTooltip(item_runes_unintegrated)
              ? { text: item_runes_unintegrated, position: 'top' }
              : {}
          "
        >
          <div class="form-group">
            <div class="form-floating">
              <input
                readonly
                class="form-control"
                :value="item_runes_unintegrated || 'None'"
                id="item_runes_unintegrated"
                disabled
              />
              <label
                class="bb-float-label optional"
                for="item_runes_unintegrated"
              >
                Runes
                <span
                  v-if="hasTooltip(item_runes_unintegrated)"
                  class="bb-orange-circle"
                ></span>
              </label>
            </div>
          </div>
        </component>
      </div>

      <!-- -------------- -->
      <!--     ROW 3      -->
      <!-- -------------- -->
      <p class="bb-sub-hdg mb-3 mt-2">Rune Spells</p>
      <div
        v-for="(line, idx) in runeSpellLines"
        :key="`item-rune-spell-line-${idx}`"
        class="row mt-2 mb-2"
      >
        <component
          style="display: block"
          :is="hasTooltip(line) ? 'ToolTip' : 'div'"
          v-bind="hasTooltip(line) ? { text: line, position: 'top' } : {}"
        >
          <div class="form-group">
            <div class="form-floating">
              <input
                readonly
                class="form-control"
                :value="line"
                :id="`item_spells_rune_${idx}`"
                disabled
              />
              <label
                class="bb-float-label optional"
                :for="`item_spells_rune_${idx}`"
              >
                Spells
                <span
                  v-if="hasTooltip(line)"
                  class="bb-orange-circle"
                ></span>
              </label>
            </div>
          </div>
        </component>
      </div>

      <!-- -------------- -->
      <!--     ROW 4      -->
      <!-- -------------- -->
      <!-- --------------------------- -->
      <!--  sorcery spells (r/o)       -->
      <!-- --------------------------- -->
      <p class="bb-sub-hdg mb-3 mt-2">Sorcery Spells</p>
      <div class="row mt-2 mb-2">
        <component
          style="display: block"
          :is="hasTooltip(item_spells_sorcery) ? 'ToolTip' : 'div'"
          v-bind="
            hasTooltip(item_spells_sorcery)
              ? { text: item_spells_sorcery, position: 'top' }
              : {}
          "
        >
          <div class="form-group">
            <div class="form-floating">
              <input
                readonly
                class="form-control"
                :value="item_spells_sorcery || 'None'"
                id="item_spells_sorcery"
                disabled
              />
              <label
                class="bb-float-label optional"
                for="item_spells_sorcery"
              >
                Spells
                <span
                  v-if="hasTooltip(item_spells_sorcery)"
                  class="bb-orange-circle"
                ></span>
              </label>
            </div>
          </div>
        </component>
      </div>

      <!-- -------------- -->
      <!--     ROW 5      -->
      <!-- -------------- -->
      <!-- --------------------------- -->
      <!--  divine spells (r/o)        -->
      <!-- --------------------------- -->
      <p class="bb-sub-hdg mb-3 mt-2">Divine Spells</p>
      <div class="row mt-2 mb-2">
        <component
          style="display: block"
          :is="hasTooltip(item_spells_divine) ? 'ToolTip' : 'div'"
          v-bind="
            hasTooltip(item_spells_divine)
              ? { text: item_spells_divine, position: 'top' }
              : {}
          "
        >
          <div class="form-group">
            <div class="form-floating">
              <input
                readonly
                class="form-control"
                :value="item_spells_divine || 'None'"
                id="item_spells_divine"
                disabled
              />
              <label
                class="bb-float-label optional"
                for="item_spells_divine"
              >
                Spells
                <span
                  v-if="hasTooltip(item_spells_divine)"
                  class="bb-orange-circle"
                ></span>
              </label>
            </div>
          </div>
        </component>
      </div>
    </div>
  </div>
</template>

<script>
import ToolTip from '../components/ToolTip.vue'

export default {
  name: 'ItemMagicTab',
  components: {
    ToolTip,
  },
  computed: {
    runeSpellLines() {
      if (!this.item_spells_rune || this.item_spells_rune === 'None') {
        return ['None']
      }

      const lines = this.item_spells_rune
        .split('\n')
        .map((line) => line.trim())
        .filter((line) => line !== '')

      return lines.length > 0 ? lines : ['None']
    },
  },
  props: {
    hasItemName: {
      type: Boolean,
      required: true,
    },
    item_runes_integrated: {
      type: String,
      required: true,
    },
    item_runes_unintegrated: {
      type: String,
      required: true,
    },
    item_spells_rune: {
      type: String,
      required: true,
    },
    item_spells_sorcery: {
      type: String,
      required: true,
    },
    item_spells_divine: {
      type: String,
      required: true,
    },
  },
  methods: {
    hasTooltip(value) {
      return !!value && value !== 'None'
    },
  },
}
</script>
